var _path, _path2, _g, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatternedLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 240,
    viewBox: "0 0 76 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.7465 210.088L12.6516 180.898L0.23885 180.906L29.3337 210.088L0 239.539L0.231387 239.772L12.1813 239.764L41.7465 210.088Z",
    fill: "url(#paint0_linear_1153_553)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5872 209.018L34.2534 238.469L34.4848 238.701L46.4348 238.694L75.9999 209.018L46.8975 179.828L34.4923 179.836L63.5872 209.018Z",
    fill: "url(#paint1_linear_1153_553)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.7465 150.146L12.6516 120.957L0.23885 120.965L29.3337 150.146L0 179.598L0.231387 179.83L12.1813 179.823L41.7465 150.146Z",
    fill: "url(#paint2_linear_1153_553)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5872 149.076L34.2534 178.528L34.4848 178.76L46.4348 178.752L75.9999 149.076L46.8975 119.887L34.4923 119.894L63.5872 149.076Z",
    fill: "url(#paint3_linear_1153_553)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.7465 90.2012L12.6516 61.0117L0.23885 61.0192L29.3337 90.2012L0 119.653L0.231387 119.885L12.1813 119.877L41.7465 90.2012Z",
    fill: "url(#paint4_linear_1153_553)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5872 89.1308L34.2534 118.582L34.4848 118.815L46.4348 118.807L75.9999 89.1308L46.8975 59.9414L34.4923 59.9489L63.5872 89.1308Z",
    fill: "url(#paint5_linear_1153_553)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.7465 30.2597L12.6516 1.07031L0.23885 1.0778L29.3337 30.2597L0 59.7113L0.231387 59.9436L12.1813 59.9361L41.7465 30.2597Z",
    fill: "url(#paint6_linear_1153_553)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5872 29.1894L34.2534 58.641L34.4848 58.8732L46.4348 58.8657L75.9999 29.1894L46.8975 0L34.4923 0.00749183L63.5872 29.1894Z",
    fill: "url(#paint7_linear_1153_553)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1153_553",
    x1: 21.5935,
    y1: 190.89,
    x2: 16.1447,
    y2: 232.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C50C88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3161AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1153_553",
    x1: 52.8912,
    y1: 206.793,
    x2: 58.4076,
    y2: 248.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C50C88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3161AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1153_553",
    x1: 21.5935,
    y1: 130.949,
    x2: 16.1447,
    y2: 172.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C50C88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3161AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1153_553",
    x1: 52.8912,
    y1: 146.852,
    x2: 58.4076,
    y2: 188.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C50C88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3161AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1153_553",
    x1: 21.5935,
    y1: 71.0037,
    x2: 16.1447,
    y2: 112.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C50C88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3161AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1153_553",
    x1: 52.8912,
    y1: 86.9062,
    x2: 58.4076,
    y2: 128.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C50C88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3161AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1153_553",
    x1: 21.5935,
    y1: 11.0623,
    x2: 16.1447,
    y2: 52.5982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C50C88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3161AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1153_553",
    x1: 52.8912,
    y1: 26.9648,
    x2: 58.4076,
    y2: 68.4857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C50C88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3161AB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternedLines);
export default __webpack_public_path__ + "static/media/patternedLines.91221fb9e7d4a4cbde6b27760e21f976.svg";
export { ForwardRef as ReactComponent };